module.exports = __webpack_public_path__ + "static/media/workbg-krx.7ee741eb.jpg";